import { Home } from "./home.feature";

export default Home;
